import { useMemo } from 'react';
import { useAuthContext } from '../providers/AuthProvider';

export function useRole(role: string | string[]) {
  const { user, loading } = useAuthContext();

  const hasRole = useMemo(() => {
    if (!user || !user.role) return false;

    const roles = Array.isArray(role) ? role : [role];
    return roles.includes(user.role);
  }, [user, role]);

  return {
    hasRole,
    loading,
    userRole: user?.role,
  };
}